import Link from 'next/link'
import Trans from 'components/atomic/Trans'
import Icon from 'components/atomic/Icon'

const box = [
  {
    titolo: 'Lezioni',
    descrizione: 'Lezioni e articoli scritti da autori e utenti della community',
    model: 'lezione',
    icon: 'cat-libro',
  },
  {
    titolo: 'Materiali',
    descrizione: 'Testi, schede didattiche e molto altro per le tue lezioni',
    model: 'strumento',
    icon: 'cat-scheda',
  },
  {
    titolo: 'Articoli',
    descrizione: 'Lezioni e articoli scritti da autori e utenti della community',
    model: 'articolo',
    icon: 'cat-libro',
  },
  {
    titolo: 'Raccolte',
    descrizione: 'Raccolte di materiali didattici degli utenti della community',
    model: 'raccolta',
    icon: 'add',
  },
]

function BoxRisorse({ href = '/' }) {
  const titolo = `Tutte le risorse`
  const descrizione = `Sfoglia i contenuti dedicati`

  return (
    <div className="box-risorse">
      <div className="box-risorse__head">
        <div className="box-risorse__head__title">
          <Trans chiave={titolo} />
        </div>
        <div className="box-risorse__head__description">
          <Trans chiave={descrizione} />
        </div>
      </div>
      <div className="box-risorse__content w-container-hub">
        {box.map((b, index) => (
          <article className="box-risorse__content__item" key={index}>
            <div className="box-risorse__content__item__left">
              <Icon id={b.icon} />
            </div>
            <div className="box-risorse__content__item__right">
              <div className="box-risorse__content__item__title">
                <Trans chiave={b.titolo} />
              </div>
              <div className="box-risorse__content__item__description">
                <Trans chiave={b.descrizione} />
              </div>
              <Link legacyBehavior href={`${href}&models=${b.model}`}>
                <a className="button button--tertiary">
                  Vedi tutti <Icon id="arrow-right" classes="button__arrow" />
                </a>
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  )
}

export default BoxRisorse
